import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IError, IFetchPayload } from "../../../interfaces/base";
import { IFetchExercisesState } from "../../../interfaces/store/exercises-interface";
import { PAGE_SIZE } from "../../../common/config";

const initialState: IFetchExercisesState = {
  exercises: [],
  loading: false,
  error: null,
  requestState: "prepare",
  operation: null,
  metadata: {
    total: 0,
    page: 0,
  },
  tableState: {
    search: "",
    sort: {
      sortBy: "updatedAt",
      sortOrder: -1,
    },
    pagination: {
      page: 0,
      limit: PAGE_SIZE,
      skip: 0,
    },
  },
};

const _fetchExercisesStart = (
  state: IFetchExercisesState,
  { payload }: PayloadAction<IFetchPayload>
) => {
  state.loading = true;
  state.error = null;
  state.requestState = "start";
  state.operation = "read";
  state.tableState.search = payload.search;
  state.tableState.sort = payload.sort;
  state.tableState.pagination = payload.pagination;
};

const _fetchExercisesSuccess = (
  state: IFetchExercisesState,
  { payload }: PayloadAction<any>
) => {
  state.exercises = payload.data.data;
  state.metadata = payload.data.metadata;
  state.loading = false;
  state.error = null;
  state.requestState = "finish";
};

const _fetchExercisesFailed = (
  state: IFetchExercisesState,
  { payload }: PayloadAction<IError>
) => {
  state.loading = false;
  state.error = payload;
  state.requestState = "error";
};

const _resetExercises = () => {
  return { ...initialState };
};

const ExercisesSlice = createSlice({
  name: "exercises",
  initialState,
  reducers: {
    fetchExercisesStart: _fetchExercisesStart,
    fetchExercisesSuccess: _fetchExercisesSuccess,
    fetchExercisesFailed: _fetchExercisesFailed,
    resetExercises: _resetExercises,
  },
});

export const {
  fetchExercisesStart,
  fetchExercisesSuccess,
  fetchExercisesFailed,
  resetExercises,
} = ExercisesSlice.actions;
export default ExercisesSlice.reducer;
